import { createApiInstance } from "./apiInstance";
import { apiCall } from "./apiCall";
import { Method } from "axios";

const lankaqrApi = createApiInstance(process.env.REACT_APP_LANKAQR_BASE_URL || "https://payment-lqr.onepay.lk/");

export const lankaqrApiCall = (
  url: string,
  method: Method = 'GET',
  data: any = null,
  header: string | null = null,
  encrypt: boolean = false
): Promise<any> => {
  return apiCall(lankaqrApi, url, method, data, header, encrypt,false);
};
